"use strict";

(() => {
    class VideoSlider extends HTMLElement {
        constructor(){
            super();
            this.size = Number(this.dataset.size);
        }

        connectedCallback() {
            const videoIframe = document.querySelector('.youtubeVimeo_video_container .video-iframe');
            const videoThumbnail = document.querySelector('.youtubeVimeo_video_container .video-thumbnail');
            
            if(videoIframe){
                videoIframe.onload = function() {
                    videoThumbnail.classList.add('loaded');
                };
            }

            setTimeout(() => {
                this.initSlider();
            }, 1000);
        }

        initSlider(){
            if(this.size < 2) return;

            const flickityElement = this;
            this.flickityCarousel = new Flickity(flickityElement, {
                wrapAround: true,
                pageDots: true,
                adaptiveHeight: true,
                prevNextButtons: false
            });
        }
    }

    document.addEventListener("DOMContentLoaded", (event) => {
        if(!customElements.get('video-slider')) customElements.define('video-slider', VideoSlider)
    });      
})();